import { render, staticRenderFns } from "./TextSettings.vue?vue&type=template&id=3f02d3b5"
import script from "./TextSettings.vue?vue&type=script&lang=ts"
export * from "./TextSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f02d3b5')) {
      api.createRecord('3f02d3b5', component.options)
    } else {
      api.reload('3f02d3b5', component.options)
    }
    module.hot.accept("./TextSettings.vue?vue&type=template&id=3f02d3b5", function () {
      api.rerender('3f02d3b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/TextSettings.vue"
export default component.exports